import { Box } from '@mui/material';
import * as React from 'react';
import { FlexBoxInline } from '../../@shared/templates';
import TabsContentMonitoringModelCpuUsage from './TabsContentMonitoringModelCpuUsage';
import TabsContentMonitoringModelUsage from './TabsContentMonitoringModelUsage';


export type TabsContentMonitoringBaseProps = {
  modelId: string;
}

type TabsContentMonitoringProps = TabsContentMonitoringBaseProps & {
  isVisible: boolean
}

const TabsContentMonitoring = (props: TabsContentMonitoringProps) => {

  return <div hidden={!props.isVisible}>
    <Box sx={{ ...FlexBoxInline, gap: "20px", marginBottom: "20px" }}>
      <Box sx={{ width: "100%" }}>
        <TabsContentMonitoringModelCpuUsage modelId={props.modelId} />
      </Box>
    </Box>
    <Box sx={{ ...FlexBoxInline, gap: "20px", marginBottom: "20px" }}>
      <Box sx={{ width: "100%" }}>
        <TabsContentMonitoringModelUsage modelId={props.modelId} />
      </Box>
    </Box>
  </div>
}

export default TabsContentMonitoring;
